import { __decorate, __metadata, __param } from "tslib";
import { DeployableManagementService } from '../DeployableManagementService';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
let PromptManagementService = class PromptManagementService extends DeployableManagementService {
    constructor(promptManagementApi, i18n) {
        super();
        this.promptManagementApi = promptManagementApi;
        this.i18n = i18n;
        this.listPromptPagination = this.promptManagementApi.listPromptPagination;
        this.getDetail = this.promptManagementApi.getPrompt;
        this.addPrompt = this.promptManagementApi.addPrompt;
        this.deletePrompt = this.promptManagementApi.deletePrompt;
        this.updatePrompt = this.promptManagementApi.updatePrompt;
        this.publishLocal = this.promptManagementApi.publishLocalPrompt;
        this.publishUpdate = this.promptManagementApi.publishUpdatePrompt;
        this.keyGen = this.promptManagementApi.keyGen;
    }
    getOptionsPlatforms() {
        return [
            { text: 'GPT-4', value: 'GPT-4' },
            { text: 'CLAUDE', value: 'CLAUDE' },
            { text: 'PatentGPT', value: 'PatentGPT' }
        ];
    }
    makePromptManagementFormData(params) {
        return _.merge({
            name: '',
            prompt_key: '',
            product: '',
            feature: '',
            platforms: [],
            content: {
                CN: '',
                EN: '',
                JP: '',
                TW: '',
            },
        }, params);
    }
};
PromptManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PromptManagementApi)),
    __param(1, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object])
], PromptManagementService);
export { PromptManagementService };
